import { Base } from "ui/Scripts/source/framework/base";
import { ListItems } from "ui/Scripts/source/framework/listItems";
import { ITaskDataRow, TaskDataRow } from "ui/Scripts/source/models/task/taskDataRow";

export interface ITaskDataRowListItems extends ListItems<ITaskDataRow> {
}

export class TaskDataRowListItems extends ListItems<TaskDataRow> implements ITaskDataRowListItems {
    constructor();
    constructor(obj: ITaskDataRowListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, TaskDataRow);
    }
}